import React from 'react';
import useMenuRedirect from 'containers/Menu/hooks/useMenuRedirect';
import './style.scss';
import { useSelector } from 'react-redux';
import { getAssets } from 'reducers/responseAsset';

export const SubMenuCard = ({ content }) => {
  const asset = useSelector(getAssets);
  const { handleRedirect } = useMenuRedirect();

  const nodeSubMenu = content;
  const { text, code } = nodeSubMenu;
  const hasImg = asset[`nav_${code}`];
  return (
    <>
      {hasImg ? (
        <img
          src={hasImg}
          alt={text}
          className="submenu__carousel_white menu-img"
          role="presentation"
          onClick={() => handleRedirect({ node:nodeSubMenu })}
          onKeyPress={() => handleRedirect({ node:nodeSubMenu })}
        />
      ) : (
        <div
          className="submenu__carousel_white"
          role="presentation"
          onClick={() => handleRedirect({ node:nodeSubMenu })}
          onKeyPress={() => handleRedirect({ node:nodeSubMenu })}
        >
          <span>{text}</span>
        </div>
      )}
    </>
  );
};
